import { Elements } from '@stripe/react-stripe-js'
import { loadStripe, type StripeElementsOptions } from '@stripe/stripe-js'
import { type FC, type PropsWithChildren } from 'react'

const StripeProvider: FC<PropsWithChildren> = ({ children }) => {
  if (import.meta.env.VITE_STRIPE_KEY == null) {
    throw new Error('VITE_STRIPE_KEY is not defined')
  }

  const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY)
  const stripeOptions = {
    locale: 'fr',
    mode: 'setup',
    cur: 'eur',
    paymentMethodTypes: ['card', 'sepa_debit'],
    paymentMethodCreation: 'manual',
  } as StripeElementsOptions

  return (
    <Elements options={ stripeOptions }
      stripe={ stripePromise }
    >
      {children}
    </Elements>
  )
}

export default StripeProvider
